import React, { Fragment } from 'react';

export const Header = () => {

    return (
        <Fragment>
            <header></header>
        </Fragment>
    );
}